import {
	AppBar,
	Backdrop,
	CircularProgress,
	IconButton,
	Toolbar,
	Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useBlog from "../commons/hooks/useBlog";
import useWebsite from "../services/useWebsite";
import Footer from "../components/footer/Footer";
import NewsCard from "../components/landing/NewsCard";
import SectionHeader from "../components/landing/SectionHeader";
import "../components/landing/landing.css";

const News = () => {
	const { blogs, retrieveBlogs, loading } = useBlog({});
	const { website } = useWebsite();
	const navigate = useNavigate();

	useEffect(() => {
		retrieveBlogs(30);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<AppBar position="static" sx={{ backgroundColor: "#081C3E" }}>
				<Toolbar>
					<IconButton
						edge="start"
						sx={{ color: "white" }}
						aria-label="Volver al inicio"
						onClick={() => navigate("/")}
					>
						<ArrowBackIcon />
					</IconButton>
					<Typography variant="h6" sx={{ color: "white" }}>
						Volver
					</Typography>
				</Toolbar>
			</AppBar>

			<main className="ld-news">
				<div className="ld-container">
					<SectionHeader
						eyebrow="Sala de prensa"
						title="Todas las noticias"
					/>
					<div className="ld-news-grid">
						{blogs.map((blog) => (
							<NewsCard key={blog.id} blog={blog} />
						))}
					</div>
				</div>
			</main>

			<Backdrop open={loading && !blogs[0]}>
				<CircularProgress color="primary" />
			</Backdrop>

			{website && <Footer item={website.footer} />}
		</div>
	);
};

export default News;
